export type UserRole = 'DICON_OPERATOR' | 'DICON_USER' | 'UNKNOWN';

export const UserRole = {
  DICON_OPERATOR: 'DICON_OPERATOR' as UserRole,
  DICON_OPERATOR_EXTERN: 'DICON_OPERATOR_EXTERN' as UserRole,
  DICON_USER: 'DICON_USER' as UserRole,
  UNKNOWN: 'UNKNOWN' as UserRole,
};
